import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  LOGIN_URL,
  FILES_URL,
  ASSISTANT_URL,
  AI_SEARCH_URL,
} from "../../utils/routes";
import { getUserDetails } from "../../core/storage/localStorage";
import { useDispatch } from "react-redux";
import { authenticateDiscoveryMagicLink, authenticateMagicLink } from "../../core/repo/accountRepo";
import SplashScreen from "../../components/SplashScreen";
import { useSnackbar } from "notistack";
import { usePostHog } from "posthog-js/react";
import { LOGIN_SUCCESS, LOGIN_FAILURE } from "../../utils/posthogEvents";

function Authenticate() {
  const posthog = usePostHog();
  const user = getUserDetails();
  const history = useHistory(); 
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  async function authenticate() {
    if (user) {
      history.push({ pathname: AI_SEARCH_URL });
    } else {
      const queryParams = new URLSearchParams(window.location.search);
      const token = queryParams.get("token");
      const tokenType = queryParams.get("stytch_token_type");
      // If a token is found, authenticate it with the appropriate method
      if (token && tokenType) {
        if (tokenType === "discovery") {
          try {
            await dispatch(authenticateDiscoveryMagicLink(token));
            history.push({
              pathname: AI_SEARCH_URL,
            });
            posthog.capture(LOGIN_SUCCESS);
          } catch (err) {
            posthog.capture(LOGIN_FAILURE, { error: err.message });
            history.push({ pathname: LOGIN_URL });
            enqueueSnackbar("Failed to Authenticate.", { variant: "error" });
          }
        }
      }
    }
  }

  useEffect(() => {
    authenticate();
  }, [user]);

  return <SplashScreen />;
}

export default Authenticate;
